import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  transactions: [],
  subscriptionTransactions: [],
  refreshList: false,
};

const transactionsSlice = createSlice({
  name: "transactions",
  initialState,
  reducers: {
    addTransaction: (state, action) => {
      const { data } = action.payload;
      state.transactions = data;
    },
    addSubscriptionTransactions: (state, action) => {
      const { data } = action.payload;
      state.subscriptionTransactions = data;
    },
    isRefreshList: (state, action) => {
      state.refreshList = action.payload;
    },
  },
});

export default transactionsSlice;
export const { addTransaction, addSubscriptionTransactions, isRefreshList } =
  transactionsSlice.actions;
